// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ответ ассистента в тест-чате: разметка из <Markdown> (жирный, списки, ссылки, код) */
.tc-md {
  white-space: normal;
  line-height: 1.6;
}
.tc-md > :first-child {
  margin-top: 0;
}
.tc-md > :last-child {
  margin-bottom: 0;
}
.tc-md p {
  margin: 0 0 10px;
}
.tc-md strong {
  font-weight: 600;
}
.tc-md ul,
.tc-md ol {
  margin: 0 0 10px;
  padding-left: 22px;
}
.tc-md li {
  margin: 3px 0;
}
.tc-md li::marker {
  color: #6b7280;
}
.tc-md h2,
.tc-md h3 {
  margin: 14px 0 6px;
  font-weight: 600;
  line-height: 1.35;
}
.tc-md h2 {
  font-size: 16px;
}
.tc-md h3 {
  font-size: 15px;
}
.tc-md code {
  padding: 1px 5px;
  border-radius: 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.9em;
  background: rgba(17, 24, 39, 0.06);
}
.tc-md a[href] {
  color: #2563eb;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.tc-md a[href]:hover {
  color: #1d4ed8;
}
`, "",{"version":3,"sources":["webpack://./src/features/test-chat/ui/markdown.css"],"names":[],"mappings":"AAAA,uFAAuF;AACvF;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qEAAqE;EACrE,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB","sourcesContent":["/* Ответ ассистента в тест-чате: разметка из <Markdown> (жирный, списки, ссылки, код) */\n.tc-md {\n  white-space: normal;\n  line-height: 1.6;\n}\n.tc-md > :first-child {\n  margin-top: 0;\n}\n.tc-md > :last-child {\n  margin-bottom: 0;\n}\n.tc-md p {\n  margin: 0 0 10px;\n}\n.tc-md strong {\n  font-weight: 600;\n}\n.tc-md ul,\n.tc-md ol {\n  margin: 0 0 10px;\n  padding-left: 22px;\n}\n.tc-md li {\n  margin: 3px 0;\n}\n.tc-md li::marker {\n  color: #6b7280;\n}\n.tc-md h2,\n.tc-md h3 {\n  margin: 14px 0 6px;\n  font-weight: 600;\n  line-height: 1.35;\n}\n.tc-md h2 {\n  font-size: 16px;\n}\n.tc-md h3 {\n  font-size: 15px;\n}\n.tc-md code {\n  padding: 1px 5px;\n  border-radius: 4px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 0.9em;\n  background: rgba(17, 24, 39, 0.06);\n}\n.tc-md a[href] {\n  color: #2563eb;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n.tc-md a[href]:hover {\n  color: #1d4ed8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
